import {
  BLUE_PIECES,
  CHARACTERS,
  randomName,
  STARTING_INDEX
} from 'helpers/constants';

export function loadProgress() {
  const lastKnownPosition =
    window.localStorage.getItem('cl-lastKnownPosition') || STARTING_INDEX;
  const storyProgress = window.localStorage.getItem('cl-storyProgress') || '';
  const worldProgress = window.localStorage.getItem('cl-terraform') || '';
  const gold = parseInt(window.localStorage.getItem('cl-gold'), 10) || 0;
  const stepCounter =
    parseInt(window.localStorage.getItem('cl-stepCounter'), 10) || 0;
  let party = JSON.parse(window.localStorage.getItem('cl-party'));
  if (!party) {
    party = startingParty;
    window.localStorage.setItem('cl-party', JSON.stringify(startingParty));
  }
  let equipment = JSON.parse(window.localStorage.getItem('cl-equipment'));
  if (!equipment) {
    equipment = [];
    window.localStorage.setItem('cl-equipment', JSON.stringify([]));
  }
  return {
    storyProgress,
    worldProgress,
    gold,
    party,
    equipment,
    lastKnownPosition,
    stepCounter
  };
}

export function addGoldToPlayer(amt) {
  const currentGold = parseInt(window.localStorage.getItem('cl-gold'), 10) || 0;
  const newTotal = currentGold + amt;
  window.localStorage.setItem('cl-gold', newTotal);
  return newTotal;
}

export function removeGoldFromPlayer(amt) {
  const currentGold = parseInt(window.localStorage.getItem('cl-gold'), 10) || 0;
  const newTotal = currentGold - amt;
  window.localStorage.setItem('cl-gold', newTotal);
  return newTotal;
}

export function upgradePieceByID(id) {
  const party = JSON.parse(window.localStorage.getItem('cl-party'));
  const piece = party.find(piece => piece.id === id);
  piece.rank += 1;
  window.localStorage.setItem('cl-party', JSON.stringify(party));
}

export function equipWeaponToPiece(item, piece) {
  piece.itemID = item.id;
  piece.item = item;
}

export function equipWeaponToPieceByID(item, pieceID) {
  const { party, equipment } = loadProgress();
  const piece = party.find(piece => piece.id === pieceID);
  if (piece.itemID) {
    equipment.push(piece.itemID);
  }
  piece.itemID = item.id;
  window.localStorage.setItem('cl-party', JSON.stringify(party));
  window.localStorage.setItem('cl-equipment', JSON.stringify(equipment));
}

export function removeItemFromPieceByID(pieceID) {
  const { party } = loadProgress();
  const piece = party.find(piece => piece.id === pieceID);
  piece.itemID = null;
  window.localStorage.setItem('cl-party', JSON.stringify(party));
}

export function addEquipmentToPlayerInventory(item) {
  const { equipment } = loadProgress();
  equipment.push(item.id);
  window.localStorage.setItem('cl-equipment', JSON.stringify(equipment));
}

export function removeEquipmentFromPlayerInventory(item) {
  const { equipment } = loadProgress();
  const removeIndex = equipment.findIndex(
    equipmentID => equipmentID === item.id
  );
  equipment.splice(removeIndex, 1);
  window.localStorage.setItem('cl-equipment', JSON.stringify(equipment));
}

export function addPieceToParty(rank, name, makeLeader = false, main = false) {
  const party = JSON.parse(window.localStorage.getItem('cl-party'));
  let highestID = 0;
  party.forEach(piece => {
    if (piece.id > highestID) {
      highestID = piece.id;
    }
  });
  const id = highestID + 1;
  const basicRankTileKey = rank + BLUE_PIECES[0];
  const customPieceTileKey = CHARACTERS[name.toLowerCase()];
  party.push({
    rank,
    id,
    tileKey: customPieceTileKey || basicRankTileKey,
    leader: false,
    name: name || randomName(),
    itemID: null,
    main
  });
  window.localStorage.setItem('cl-party', JSON.stringify(party));
  if (makeLeader) {
    setPieceAsLeader(party[party.length - 1]);
  }
}

export function removePieceFromParty(nameOrID) {
  const party = JSON.parse(window.localStorage.getItem('cl-party'));
  const removeIndex = party.findIndex(piece => {
    return piece.id === nameOrID || piece.name === nameOrID;
  });
  party.splice(removeIndex, 1);
  window.localStorage.setItem('cl-party', JSON.stringify(party));
}

export function setPieceAsLeader(newLeader) {
  const party = JSON.parse(window.localStorage.getItem('cl-party'));
  party.forEach(piece => {
    piece.leader = false;
    if (newLeader.id === piece.id) {
      piece.leader = true;
    }
  });
  window.localStorage.setItem('cl-party', JSON.stringify(party));
}

export function resetParty() {
  window.localStorage.setItem('cl-party', JSON.stringify(startingParty));
  window.localStorage.setItem('cl-equipment', JSON.stringify([]));
}

const startingParty = [
  {
    rank: 0,
    id: 1,
    tileKey: CHARACTERS.fayette,
    name: 'Fayette',
    leader: true,
    main: true,
    itemID: null
  }
];

export function clearStoryProgress() {
  window.localStorage.removeItem('cl-storyProgress');
}

// Increment step counter to track player movement/progress
export function incrementStepCounter() {
  const currentSteps =
    parseInt(window.localStorage.getItem('cl-stepCounter'), 10) || 0;
  const newStepCount = currentSteps + 1;
  window.localStorage.setItem('cl-stepCounter', newStepCount.toString());
  return newStepCount;
}

export function savePlayerPosition(position) {
  const data =
    typeof position === 'object' ? JSON.stringify(position) : position;
  window.localStorage.setItem('cl-lastKnownPosition', data);

  // Increment step counter since position changed
  incrementStepCounter();

  // Save all progress to file after updating localStorage
  saveAllProgressToFile();
}

// World Progress
export function saveWorldProgress(id) {
  saveProgress('cl-terraform', id);
}

export function removeWorldProgress(id) {
  removeProgress('cl-terraform', id);
}

// Read all progress data from a file using greenworks
export function readProgressFromFile() {
  return new Promise((resolve, reject) => {
    if (!window.greenworks) {
      console.warn('Greenworks not available, skipping file read');
      return resolve(null);
    }

    try {
      // Get Steam user ID for filename
      const steamUserId = window.steamUserInfo?.staticAccountId || 'unknown';
      const filename = `cl_progress_${steamUserId}.txt`;

      // Read from file using greenworks
      window.greenworks.readTextFromFile(
        filename,
        content => {
          try {
            const saveData = JSON.parse(content);
            console.log(`Progress loaded from file: ${filename}`);
            resolve(saveData.progress || saveData); // Handle both new format with timestamp and old format
          } catch (parseError) {
            console.error('Failed to parse progress file content:', parseError);
            resolve(null);
          }
        },
        error => {
          console.log('No cloud save file found or failed to read:', error);
          resolve(null); // Not an error - just no cloud save exists
        }
      );
    } catch (error) {
      console.error('Error in readProgressFromFile:', error);
      resolve(null);
    }
  });
}

// Compare local and cloud progress to determine which is better
export function compareProgress(localProgress, cloudProgress) {
  if (!cloudProgress) return 'local';
  if (!localProgress) return 'cloud';

  // Compare story progress length (more progress is better)
  const localStoryLength = localProgress.storyProgress?.length || 0;
  const cloudStoryLength = cloudProgress.storyProgress?.length || 0;
  if (cloudStoryLength > localStoryLength) return 'cloud';
  if (localStoryLength > cloudStoryLength) return 'local';

  // If story progress is equal, use step counter as tie breaker
  const localStepCount = localProgress.stepCounter || 0;
  const cloudStepCount = cloudProgress.stepCounter || 0;
  if (cloudStepCount > localStepCount) return 'cloud';
  if (localStepCount > cloudStepCount) return 'local';

  // If both story progress and step count are equal, prefer local (no need to restore)
  return 'local';
}

// Restore progress from cloud data
export function restoreProgressFromCloud(cloudProgress) {
  if (!cloudProgress) {
    console.warn('No cloud progress data to restore');
    return;
  }

  try {
    // Restore all progress data to localStorage
    if (cloudProgress.lastKnownPosition !== undefined) {
      const positionData =
        typeof cloudProgress.lastKnownPosition === 'object'
          ? JSON.stringify(cloudProgress.lastKnownPosition)
          : cloudProgress.lastKnownPosition;
      window.localStorage.setItem('cl-lastKnownPosition', positionData);
    }

    if (cloudProgress.storyProgress !== undefined) {
      window.localStorage.setItem(
        'cl-storyProgress',
        cloudProgress.storyProgress
      );
    }

    if (cloudProgress.worldProgress !== undefined) {
      window.localStorage.setItem('cl-terraform', cloudProgress.worldProgress);
    }

    if (cloudProgress.gold !== undefined) {
      window.localStorage.setItem('cl-gold', cloudProgress.gold.toString());
    }

    if (cloudProgress.party !== undefined) {
      window.localStorage.setItem(
        'cl-party',
        JSON.stringify(cloudProgress.party)
      );
    }

    if (cloudProgress.equipment !== undefined) {
      window.localStorage.setItem(
        'cl-equipment',
        JSON.stringify(cloudProgress.equipment)
      );
    }

    if (cloudProgress.stepCounter !== undefined) {
      window.localStorage.setItem(
        'cl-stepCounter',
        cloudProgress.stepCounter.toString()
      );
    }

    console.log('Progress restored from cloud save');
  } catch (error) {
    console.error('Error restoring progress from cloud:', error);
  }
}

// Clear progress file from Steam cloud
export function clearProgressFromCloud() {
  if (!window.greenworks) {
    console.warn('Greenworks not available, skipping cloud file clear');
    return Promise.resolve(false);
  }

  return new Promise(resolve => {
    try {
      // Get Steam user ID for filename
      const steamUserId = window.steamUserInfo?.staticAccountId || 'unknown';
      const filename = `cl_progress_${steamUserId}.txt`;

      // Clear the file by writing empty data
      window.greenworks.saveTextToFile(
        filename,
        '',
        () => {
          console.log(`Cloud progress file cleared: ${filename}`);
          resolve(true);
        },
        error => {
          console.error('Failed to clear cloud progress file:', error);
          resolve(false);
        }
      );
    } catch (error) {
      console.error('Error in clearProgressFromCloud:', error);
      resolve(false);
    }
  });
}

// Load progress with cloud sync - checks cloud save and uses better progress
export async function loadProgressWithCloudSync() {
  try {
    // Load local progress
    const localProgress = loadProgress();

    // Load cloud progress
    const cloudProgress = await readProgressFromFile();

    // Compare and determine which to use
    const betterProgress = compareProgress(localProgress, cloudProgress);

    if (betterProgress === 'cloud' && cloudProgress) {
      console.log('Cloud progress is better, restoring from cloud');
      restoreProgressFromCloud(cloudProgress);
      return loadProgress(); // Return the newly restored progress
    } else {
      console.log('Local progress is better or equal, using local');
      return localProgress;
    }
  } catch (error) {
    console.error('Error in loadProgressWithCloudSync:', error);
    return loadProgress(); // Fallback to local progress
  }
}

// Save all progress data to a file using greenworks
export function saveAllProgressToFile() {
  if (!window.greenworks) {
    console.warn('Greenworks not available, skipping file save');
    return;
  }

  try {
    // Get all progress data using the existing loadProgress function
    const allProgressData = loadProgress();

    // Add timestamp for versioning
    const saveData = {
      timestamp: Date.now(),
      progress: allProgressData
    };

    // Get Steam user ID for filename
    const steamUserId = window.steamUserInfo?.staticAccountId || 'unknown';
    const filename = `cl_progress_${steamUserId}.txt`;

    // Save to file using greenworks
    window.greenworks.saveTextToFile(
      filename,
      JSON.stringify(saveData, null, 2),
      () => {
        console.log(`Progress saved to file: ${filename}`);
      },
      error => {
        console.error('Failed to save progress to file:', error);
      }
    );
  } catch (error) {
    console.error('Error in saveAllProgressToFile:', error);
  }
}

export function saveProgress(storageKey, id) {
  const currentForms = window.localStorage.getItem(storageKey);
  const currentSet = new Set((currentForms && currentForms.split('-')) || []);
  currentSet.add(id);
  const newForms = [...currentSet].join('-');
  window.localStorage.setItem(storageKey, newForms);

  // Save all progress to file after updating localStorage
  saveAllProgressToFile();
}

function removeProgress(storageKey, id) {
  const currentForms = window.localStorage.getItem(storageKey);
  const currentSet = new Set((currentForms && currentForms.split('-')) || []);
  currentSet.delete(id);
  const newForms = [...currentSet].join('-');
  window.localStorage.setItem(storageKey, newForms);
}

export function getWorldProgress() {
  const currentForms = window.localStorage.getItem('cl-terraform');
  return currentForms ? currentForms.split('-') : [];
}

export const getBattleResultHighScores = levelIndex => {
  const highScores =
    JSON.parse(window.localStorage.getItem('chesslike-highscores')) || {};
  if (!levelIndex) {
    return highScores;
  } else {
    return highScores[levelIndex];
  }
};

export const getPlayerInfo = () => {
  const name = window.localStorage.getItem('chesslike-user');
  const id = window.localStorage.getItem('chesslike-userid');
  const token = window.localStorage.getItem('chesslike-token');
  return { name, id, token };
};

export function logout() {
  window.localStorage.removeItem('chesslike-user');
  window.localStorage.removeItem('chesslike-userid');
  window.localStorage.removeItem('chesslike-token');
  clearPlayerData();
  window.location.reload();
}

export function clearWorldProgress() {
  window.localStorage.removeItem('cl-terraform');
}

export function clearPlayerData({ preserveHighScores = false } = {}) {
  window.localStorage.removeItem('cl-terraform');
  window.localStorage.removeItem('cl-storyProgress');
  window.localStorage.removeItem('cl-gold');
  window.localStorage.removeItem('cl-party');
  window.localStorage.removeItem('cl-equipment');
  window.localStorage.removeItem('cl-lastKnownPosition');
  window.localStorage.removeItem('cl-stepCounter');
  if (!preserveHighScores) {
    window.localStorage.removeItem('chesslike-highscores');
  }

  // Also clear the cloud save file to keep local and cloud in sync
  return clearProgressFromCloud();
}
